import { Box, Stack, Typography } from '@mui/material';
import { keyframes, styled } from '@mui/material/styles';
import { Sparkles } from 'lucide-react';
import { PropsWithChildren } from 'react';


// ─── Component ────────────────────────────────────────────────────────────────

export const ChatCard = ({children}: PropsWithChildren) => (
  <CardRoot sx={{ height: '100%' }}>
    <Stack direction="row" alignItems="center" gap={1.5} sx={{ px: 3, py: 2, borderBottom: '1px solid #f3f4f6' }}>
      <AiCircle>
        <ShimmerOverlay />
        <Sparkles size={20} style={{ position: 'relative', zIndex: 1 }} />
      </AiCircle>
      <Box>
        <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: '#111827', lineHeight: 1.2, mb: 0.25 }}>
          A.I. Medicare Copilot
        </Typography>
        <Typography sx={{ fontSize: '0.75rem', color: '#6b7280' }}>
          Your personalized guide
        </Typography>
      </Box>
    </Stack>

    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      {children}
    </Box>
  </CardRoot>
);

// ─── Animations ───────────────────────────────────────────────────────────────

const shimmerAnim = keyframes`
  from { transform: translateX(-100%); }
  to   { transform: translateX(200%); }
`;

// ─── Styled ───────────────────────────────────────────────────────────────────

const CardRoot = styled(Box)({
  borderRadius: 24,
  position: 'sticky',
  top: 96,
  border: '1px solid #f3f4f6',
  background: '#ffffff',
  boxShadow: '0 12px 40px rgba(0,0,0,0.1)',
  maxHeight: 'calc(100vh - 300px)',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: 0,
  zIndex: 1400,
});

const AiCircle = styled(Box)({
  width: 40,
  height: 40,
  flexShrink: 0,
  borderRadius: '50%',
  background: 'linear-gradient(135deg, #3b82f6, #9333ea)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  position: 'relative',
  overflow: 'hidden',
  boxShadow: '0 4px 6px -1px rgba(0,0,0,0.15)',
});

const ShimmerOverlay = styled('div')({
  position: 'absolute',
  inset: 0,
  background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
  animation: `${shimmerAnim} 2s infinite`,
  pointerEvents: 'none',
});
